import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// ArticleSearch fetch

export interface ArticleSearchFetchAction extends Action {
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly query: string;
    readonly after: number;
}

export const ARTICLE_SEARCH_FETCH_TRIGGER = "ARTICLE_SEARCH_FETCH_TRIGGER";
export interface ArticleSearchFetchTriggerAction extends ArticleSearchFetchAction {
    readonly type: typeof ARTICLE_SEARCH_FETCH_TRIGGER;
}
export const ARTICLE_SEARCH_FETCH_REQUEST = "WIKI_ARTICLE_SEARCH_FETCH_REQUEST";
export interface ArticleSearchFetchRequestAction
    extends ArticleSearchFetchAction, APIRequestAction {
    readonly type: typeof ARTICLE_SEARCH_FETCH_REQUEST;
}
export interface ArticleSearchFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        articles: number[];
    };
}
export const ARTICLE_SEARCH_FETCH_SUCCESS = "WIKI_ARTICLE_SEARCH_FETCH_SUCCESS";
export interface ArticleSearchFetchSuccessAction
    extends ArticleSearchFetchAction, APISuccessAction<ArticleSearchFetchNormalizedResponse> {
    readonly type: typeof ARTICLE_SEARCH_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly resultsCount: number;
}
export const ARTICLE_SEARCH_FETCH_FAILURE = "WIKI_ARTICLE_SEARCH_FETCH_FAILURE";
export interface ArticleSearchFetchFailureAction
    extends ArticleSearchFetchAction, APIFailureAction {
    readonly type: typeof ARTICLE_SEARCH_FETCH_FAILURE;
}

export const articleSearchFetchTrigger = (
    articleSlug: string,
    categorySlug: string,
    query: string,
    after: number,
): ArticleSearchFetchTriggerAction => ({
    type: ARTICLE_SEARCH_FETCH_TRIGGER,
    articleSlug,
    categorySlug,
    query,
    after,
});
export const articleSearchFetchApi = {
    request: (
        articleSlug: string,
        categorySlug: string,
        query: string,
        after: number,
    ): ArticleSearchFetchRequestAction => ({
        type: ARTICLE_SEARCH_FETCH_REQUEST,
        articleSlug,
        categorySlug,
        query,
        after,
    }),
    success: (
        articleSlug: string,
        categorySlug: string,
        query: string,
        after: number,
        hasNext: number,
        hasPrevious: number,
        resultsCount: number,
        response: ArticleSearchFetchNormalizedResponse,
    ): ArticleSearchFetchSuccessAction => ({
        type: ARTICLE_SEARCH_FETCH_SUCCESS,
        articleSlug,
        categorySlug,
        query,
        after,
        hasNext,
        hasPrevious,
        resultsCount,
        response,
    }),
    failure: (
        articleSlug: string,
        categorySlug: string,
        query: string,
        after: number,
        error: any,
    ): ArticleSearchFetchFailureAction => ({
        type: ARTICLE_SEARCH_FETCH_FAILURE,
        articleSlug,
        categorySlug,
        query,
        after,
        error,
    }),
};
